module.exports = __webpack_public_path__ + "img/card_idiom.89db21e8.png";